import React from 'react';
import { useTranslation } from 'react-i18next';
import Faqs, { type Faq } from '@wix/da-shared-react/pkg/Faqs';
import s from './FaqBlock.scss';

export interface Props {
  faqs: Faq[];
}

const FaqBlock: React.FC<Props> = ({ faqs }) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <h2 className={s['title']}>{t('packagePicker.block.faqs.title')}</h2>
      <Faqs faqs={faqs} />
    </div>
  );
};

FaqBlock.displayName = 'FaqBlock';

export default FaqBlock;
